var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dense":"","clipped-left":"","dark":"","color":"#60687b"}},[_vm._t("default"),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.applicationName))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }